import * as React from "react";
import IconCaretDown from "components/Icons/IconCaretDown";
import MuiRegularButton, { MuiRegularButtonProps } from "components/MuiExtras/Button/MuiRegularButton";

interface IProps {
    text: string | JSX.Element;
}

type Props = IProps & MuiRegularButtonProps;

const ButtonDropdown: React.FC<Props> = (props) => {
    const { text, ...rest } = props;
    return (
        <MuiRegularButton
            {...rest}
        >
            {text}
            <IconCaretDown fixedWidth />
        </MuiRegularButton>
    );
}

ButtonDropdown.defaultProps = {
    color: "inherit"
}

export default ButtonDropdown;